module.exports = __webpack_public_path__ + "static/media/php.54241962.svg";